import React from "react";

export const Header = () => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h2>
                  İş Hukuku
                </h2>
                <p>İş sözleşmelerinin tanzimi, hukuki<br/> anlaşmazlıkların çözümü</p>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  BİZE ULAŞIN
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
